import React from 'react';
import { branch } from 'baobab-react/higher-order';
import FacetGroup from './FacetGroup';

const FacetSection = ({ facets }) => {

	const facetGroups = facets
		.filter(facetGroup => facetGroup.value !== 'fireDuration')
		.filter(facetGroup => facetGroup.value !== 'itemsToProtect')
		.map((facetGroup, index) => <FacetGroup key={index} facetGroup={facetGroup} />
		);
	return (
		<div className="facet-group">
			{facetGroups}
		</div>
	);
};

export default branch({
	facets: ['productSearchResults', 'facets']
}, FacetSection);


// WEBPACK FOOTER //
// ./src/pages/productSearch/FacetSection.js